import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';
import type { AvatarGroupComponentType } from '@unifyapps/defs/blocks/AvatarGroup/types';

const importAvatarGroupComponent = () =>
  import(
    /* webpackChunkName: "avatar-group-block" */
    './AvatarGroup'
  );

const AvatarGroup = lazy(importAvatarGroupComponent);

class AvatarGroupBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return AvatarGroup;
  }

  get type(): ComponentTypeUnionType {
    return 'AvatarGroup';
  }

  get initialStateGetter() {
    return (block: BlockType) => ({
      id: block.id,
      ..._pick(block.component as AvatarGroupComponentType, [
        'content',
        'appearance',
        'componentType',
      ]),
    });
  }

  preload() {
    return {
      blockPreload: importAvatarGroupComponent,
    };
  }
}

export default AvatarGroupBlockStateDefinition;
